/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const GET_LIST_DOCUMENTS_REQUEST = "GET_LIST_DOCUMENTS_REQUEST";
export const GET_LIST_DOCUMENTS_SUCCESS = "GET_LIST_DOCUMENTS_SUCCESS";
export const GET_LIST_DOCUMENTS_FAILURE = "GET_LIST_DOCUMENTS_FAILURE";

export const DOCUMENT_SELECTED = "DOCUMENT_SELECTED";

export const SIGN_DOCUMENT_REQUEST = "SIGN_DOCUMENT_REQUEST";
export const SIGN_DOCUMENT_SUCCESS = "SIGN_DOCUMENT_SUCCESS";
export const SIGN_DOCUMENT_FAILURE = "SIGN_DOCUMENT_FAILURE";

export const UPDATE_LIST_DOCUMENT = 'UPDATE_LIST_DOCUMENT';

export const INITIAL_DATA = 'INITIAL_DATA';
export const SET_VALUE = 'SET_VALUE';